import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import { ReceiptDetails } from '@/store/types';
import { dateFormat, numGroup } from '@/utils/filters';
import services from '@/api/services';

export default class TaxpayerReceiptDtailsStore extends ListStore<any> {
  @computed get processedData() {
    if (!this.data) return;
    return this.data;
  }

  @action.bound async fetch(id: number) {
    this.isFetching = true;
    try {
      const { data } = await services.receipts.getReceiptImage(id);
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
